import React, {useState} from "react";
import TableAuthRequests from "../components/tables/TableAuthRequests";
import useAxios from 'axios-hooks';
import MaterialTable from 'material-table';

const AuthRequests = () => {

    const [skip, setSkip] = useState(0);
    const [limit, setLimit] = useState(5);
    const increment = skip * limit

    const [{data: authRequests, loading, error}, getExecute] = useAxios({
            url: "/api/auth_requests/?skip=" + increment + "&limit=" + limit
        },
        {useCache: false}
    )

    return (
        <div>
            {authRequests ? <TableAuthRequests authRequests={authRequests} limit={limit} setLimit={setLimit} skip={skip} setSkip={setSkip}
                               updateList={() => {getExecute()}}/> :
                loading ? <MaterialTable title={''} isLoading={true} options={{loadingType: 'overlay'}}/> : null}
            {error ? <p>ERROR</p> : null}
        </div>
    )

}

export default AuthRequests;